// ONE place for the avoir_model_enabled switch OFF treatment (owner ruling 2026-10-09: grey, don't hide).
// useAvoirGate() -> { enabled, reason, props } ; props = spread on a button/tab: disabled + aria-disabled + title (the reason).
// <AvoirGateCard title> = a collapsed card (title + reason) for list sections. Same reason text everywhere (avoir:gate.off, EN+FR).
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../../context/AuthContext';
import useAvoirModel from './avoirModelStore';

export default function useAvoirGate({ adminOnly = false } = {}) {
  const { t } = useTranslation('avoir'); const { isAdmin } = useAuth();
  const enabled = useAvoirModel() === true;
  const reason = enabled ? '' : (t('gate.off') + (adminOnly && !isAdmin ? ` ${t('gate.adminOnly')}` : ''));
  return { enabled, reason, props: enabled ? {} : { disabled: true, 'aria-disabled': true, title: reason, 'data-gated': 'avoir-off' } };
}

// Admin-only ACTION a non-admin cannot take: greyed with the reason (owner ruling P3U-22: grey actions, hide data). props = {} for admins.
export function useAdminOnly() {
  const { t } = useTranslation('avoir'); const { isAdmin } = useAuth(); const reason = isAdmin ? '' : t('gate.adminOnly');
  return { isAdmin, reason, props: isAdmin ? {} : { disabled: true, 'aria-disabled': true, title: reason, 'data-gated': 'admin-only' } };
}

// Reusable wrapper (block 1; block 5 reuses it for Release overpayment / Release credits / Refund customer): <AdminOnlyGate>{(props) => <button {...props}>..</button>}</AdminOnlyGate>. Non-admin: the control is greyed with 'Admin only', never hidden.
export function AdminOnlyGate({ children }) { return children(useAdminOnly().props); }

export function GateReason({ reason }) { return <span className="sub" data-testid="avoir-gate-reason">{reason}</span>; }

export function AvoirGateCard({ title, reason, children, testid = 'avoir-gate-card' }) {
  return (
    // eslint-disable-next-line jsx-a11y/role-supports-aria-props -- aria-disabled kept on purpose: the gated card announces itself as off, no visual effect
    <section className="card" data-testid={testid} data-gated="avoir-off" aria-disabled="true" style={{ marginTop: 18, padding: '10px 14px', opacity: 0.85 }}>
      <div className="tbar"><div className="tbar-l"><span className="tbar-title">{title}</span></div>{children && <div className="tbar-r" style={{ display: 'flex', gap: 8 }}>{children}</div>}</div>
      <GateReason reason={reason} />
    </section>
  );
}
